module.exports = __webpack_public_path__ + "img/landing_slider_private_offers.f7ed0d62.jpeg";